module["exports"] = [
  "#####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/it/address/postcode.js
 ** module id = 755
 ** module chunks = 0
 **/